const createShortcut = (shortcut) => shortcut;
export {
  createShortcut
};
//# sourceMappingURL=shortcuts.js.map
